(function () {
  function init(root) {
    const select = root.querySelector("#GiftCollectionSelect");
    const results = root.querySelector("#GiftCollectionResults");
    const sectionId = root.dataset.sectionId;

    if (!select || !results || !sectionId) return;

    let abortController = null;

    async function load(handle) {
      if (!handle) {
        results.innerHTML = "";
        return;
      }

      if (abortController) abortController.abort();
      abortController = new AbortController();

      results.setAttribute("aria-busy", "true");
      results.innerHTML = "<p>Even laden…</p>";

        try {
        // Neem preview params mee (belangrijk in Theme Editor / preview)
        const currentParams = new URLSearchParams(window.location.search);

        // Bouw de section render URL
        const urlParams = new URLSearchParams();
        urlParams.set("section_id", sectionId);

        // Als je in een preview werkt: voeg preview_theme_id toe
        const previewThemeId = currentParams.get("preview_theme_id");
        if (previewThemeId) urlParams.set("preview_theme_id", previewThemeId);

        // (optioneel maar handig) soms staat er ook _fd of andere editor params
        // die hoeven niet, maar kan geen kwaad. Laat ik bewust weg.

        const url = `/collections/${encodeURIComponent(handle)}?${urlParams.toString()}`;

        const res = await fetch(url, {
            signal: abortController.signal,
            headers: { "X-Requested-With": "XMLHttpRequest" }
        });

        if (!res.ok) throw new Error("Fetch failed");

        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, "text/html");

        // Pak alleen de root van de section (zodat je geen extra rommel inject)
        const incoming = doc.querySelector("[data-gift-grid-root]");
        results.innerHTML = incoming ? incoming.outerHTML : "<p>Kon producten niet laden.</p>";
        } catch (e) {
        if (e.name === "AbortError") return;
        results.innerHTML = "<p>Sorry, laden ging mis. Probeer opnieuw.</p>";
        } finally {
        results.removeAttribute("aria-busy");
        }
    }

    select.addEventListener("change", () => load(select.value));
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".gift-finder").forEach(init);
  });
})();
